import Wrapper from "../../../layout/Wrapper";
import ApproveAgentComponent from "../../../screens/approveds/agent";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Approved Cancel Agent",
	description: "",
};

export default function ApproveLifeInsurance() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<ApproveAgentComponent />
		</Wrapper>
	);
}